<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-tit"><a id="page_v"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toc1"><a href="#/xhtml/05_Chapter1"><span class="sp_toc">Chapter 1</span> The Lion Has Wings</a></h2>
<h2 class="toc1"><span href="#/xhtml/06_Chapter2" title="Link target outside of Sample"><span class="sp_toc">Chapter 2</span> The First of the Few</span></h2>
<h2 class="toc1"><span href="#/xhtml/07_Chapter3" title="Link target outside of Sample"><span class="sp_toc">Chapter 3</span> Angels One Five</span></h2>
<h2 class="toc1"><span href="#/xhtml/08_Chapter4" title="Link target outside of Sample"><span class="sp_toc">Chapter 4</span> Reach for the Sky</span></h2>
<h2 class="toc1"><span href="#/xhtml/09_Chapter5" title="Link target outside of Sample"><span class="sp_toc">Chapter 5</span> Battle of Britain</span></h2>
<h2 class="toc1"><span href="#/xhtml/10_Chapter6" title="Link target outside of Sample"><span class="sp_toc">Chapter 6</span> First Light</span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter7" title="Link target outside of Sample"><span class="sp_toc">Chapter 7</span> ‘Last Light?’</span></h2>
<h2 class="toc2"><span href="#/xhtml/12_Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></h2>
<h2 class="toc2"><span href="#/xhtml/13_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="toc2"><span href="#/xhtml/14_Other_Books" title="Link target outside of Sample">Other Books by Dilip Sarkar</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?68fcf002